var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressSixGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 72,
    viewBox: "0 0 32 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    rx: 15.5,
    fill: "#575757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9922 21.1875C13.9141 21.1875 11.7109 19.75 11.7109 15.5703V15.5547C11.7109 11.7578 13.3281 9.53906 16.0859 9.53906C18 9.53906 19.4297 10.6328 19.8047 12.2734L19.8281 12.375H18.3984L18.3672 12.2891C18.0312 11.3594 17.2266 10.7812 16.0703 10.7812C13.9688 10.7812 13.1406 12.8203 13.0781 15.1875C13.0703 15.2656 13.0703 15.3438 13.0703 15.4297H13.1016C13.5547 14.4297 14.7109 13.6172 16.2422 13.6172C18.3906 13.6172 19.9844 15.2031 19.9844 17.3438V17.3594C19.9844 19.5781 18.2969 21.1875 15.9922 21.1875ZM13.4062 17.3438C13.4062 18.7891 14.5312 19.9375 15.9766 19.9375C17.4141 19.9375 18.5547 18.8125 18.5547 17.3906V17.375C18.5547 15.9062 17.4844 14.8516 16 14.8516C14.5234 14.8516 13.4062 15.8984 13.4062 17.3359V17.3438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressSixGrey);
export default __webpack_public_path__ + "static/media/progressSixGrey.6255d9cb72818f9f41e90b329a319c42.svg";
export { ForwardRef as ReactComponent };